import RepositoryFactory from "repositories/RepositoryFactory";
import { EventEmitter } from "events";

const initialPopupState = {
    popup: {
        isOpen: null,
        mainTitle: "",
        subTitle: "",
        mainButtonAction: null,
        mainButtonText: "",
        closingAction: null,
    },
}

const initialTzurPopupState = {
    tzurPopup: {
        isOpen: null,
        Title: "",
        Component:""
    }
}

const initialTzurPopupCenterState = {
    tzurPopupCenter: {
        isOpen: null,
        Title: "",
        Component:"",
        note:""
    }
}

const initialNotificationState = {
    notification : {
        isOpen: null,
        mainTitle: "",
        subTitle: "",
        mainButtonAction: null,
        ButtonImage: "",
        closingAction: null,
    },
}

const initialState = {
    ...initialPopupState,
    ...initialNotificationState,
    ...initialTzurPopupState,
    ...initialTzurPopupCenterState,
    business: null,
    deliveryOrders: null,
    fromLoginPage: false,
    isMobile: null,
    isModalLoading: false,
    isMobileMenuOpen: false,
    repositoryFactory: RepositoryFactory,
    isAdmin: null,
    isMobileApp: false,
    isIPhone: false,
    openBiometricAsDefault:false,
    pageType: null,
    lookup: null,
    T: null,
    settings: null,
    cfg: null,
    adminOtpLoginTempData: null,
    reviewsPageData: null,
    otp:null,
    hash:null,
    mobileAppWrapperData: {},
    recaptcha: {
        handleRecaptchaResponse: null,
        submitRef: null
    },
    globalEventEmitter: new EventEmitter()
};

export default initialState;
